import React, { useEffect, useState } from "react";
import DefaultLayout from "../../components/DefaultLayout";
import { showNotification } from "../../utils/error";
import axiosInstance from "../../utils/axiosInstance";
import SubscriptionListTable from "../../components/Tables/SubscriptionListTable";
const baseUrl = process.env?.REACT_APP_BASE_URL;

const SubscriptionList = () => {
  const theads = [
    { name: "Wallet Address", width: "20%" },
    { name: "Email", width: "20%" },
    { name: "Amount", width: "15%" },
    { name: "Next Payment Date", width: "20%" },
    { name: "Created At", width: "15%" },
    { name: "Subscription Status", width: "15%" },
  ];
  const [allWallets, setAllWallets] = useState([]);
  const [filteredWallets, setFilteredWallets] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20); // Number of items to display per page
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState(0);

  const getAllWallets = async () => {
    setIsFetching(true);
    try {
      const response = await axiosInstance.get(
        baseUrl +
          "/subscription/fetch-all" +
          `?size=${itemsPerPage}&offset=${
            itemsPerPage === totalCount ? 0 : currentPage - 1
          }&search=${encodeURIComponent(searchTerm)}`
      );

      if (response?.data?.success) {
        const formattedData = response?.data?.data?.map(subscription => ({
          wallet_address: subscription.wallet_id,
          email: subscription.email,
          amount: subscription.plan.amount,
          plan: subscription.plan.name,
          next_payment_date: new Date(subscription.next_payment_date).toLocaleDateString(),
          created_at: new Date(subscription.created_at).toLocaleDateString(),
          subscription_status: subscription.subscription_status
        }));
        setAllWallets(formattedData);
        setTotalCount(response?.data?.totalCount);
        setTimeout(() => {
          setIsFetching(false);
        }, 1000);
      } else {
        setTimeout(() => {
          setIsFetching(false);
        }, 1000);
      }
    } catch (error) {
      setTimeout(() => {
        setIsFetching(false);
      }, 1000);

      showNotification("error", error.message);
    }
  };

  useEffect(() => {
    getAllWallets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsPerPage, currentPage]);
  useEffect(() => {
    setFilteredWallets(allWallets);
  }, [allWallets]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleItemsPerPageChange = (data) => {
    if (totalCount === 1) {
      return;
    }
    if (data === "See All") {
      setItemsPerPage(totalCount);
      setCurrentPage(1);
    } else {
      setItemsPerPage(data);
      setCurrentPage(1);
    }
  };
  const nextPage = () => {
    if (currentPage < Math.ceil(totalCount / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Go to previous page
  const prevPage = () => {
    if (itemsPerPage === totalCount || allWallets?.length === totalCount) {
      return;
    }
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle search input change (client-side filter)
  const handleSearchChange = (event) => {
    const userInput = event.target.value;
    setSearchTerm(userInput);
    if (!userInput) {
      setFilteredWallets(allWallets);
    } else {
      setFilteredWallets(
        allWallets.filter(sub =>
          sub.email && sub.email.toLowerCase().includes(userInput.toLowerCase())
        )
      );
    }
  };

  return (
    <>
      <DefaultLayout
        setIsOpenNewUser={() => {}}
        handleSearchChange={handleSearchChange}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        getAllWallets={getAllWallets}>
        <SubscriptionListTable
          theads={theads}
          allWallets={filteredWallets}
          prevPage={prevPage}
          nextPage={nextPage}
          paginate={paginate}
          currentPage={currentPage}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          itemsPerPage={itemsPerPage}
          isFetching={isFetching}
          totalCount={totalCount}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      </DefaultLayout>
    </>
  );
};

export default SubscriptionList;
